module.exports = __webpack_public_path__ + "img/by.58ae33e6.svg";